import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import { closeModal, createCampaign, gotoUrl } from "../../actions";
import styles from "../../components/Modal.module.css";

export class CreateCampaignModal extends Component {
  constructor(props) {
    super(props);
    this.create = this.create.bind(this);
    this.nameRef = createRef();
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  create(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, parentCampaign } = this.props;
    this.props
      .createCampaign(accountId, {
        name: this.nameRef?.current.value,
        parentCampaign,
      })
      .then((data) => {
        const nextId = data.data.id;
        return this.props.gotoUrl(`/clients/${accountId}/campaigns/${nextId}`);
      })
      .then(this.props.closeModal);
  }

  render() {
    return (
      <Modal>
        <ModalHeader>Create Folder</ModalHeader>
        <ModalContent>
          <form onSubmit={this.create} className={styles.flex}>
            <label>Name</label>
            <input ref={this.nameRef} autoFocus />
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.create}>Create</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

CreateCampaignModal.propTypes = {
  createCampaign: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const accountId = params.accountId;
  const parentCampaign = params.parentCampaign;

  return {
    accountId,
    parentCampaign,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  createCampaign,
  gotoUrl,
})(CreateCampaignModal);
